<div *ngIf="modalType === 'AddtoFav'">
  <div class="modal-header">
    <h3
      class="modal-title"
      [innerHTML]="'CARDOPERATIONS_HEADER_LABEL' | translate"
    ></h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <app-query-and-fav
    [modalType]="modalType"
    (onError)="onError()"
  ></app-query-and-fav>
  <div class="modal-footer"></div>
</div>

<div *ngIf="(modalType === 'OnlineCharge') || (modalType === 'OnlineChargeFav') ">
  <div class="modal-header">
    <button 
      type="button" 
      class="close"
      (click)="activeModal.close('Close click')"
    >{{ 'CARDOPERATIONS_ONLINE_CHARGE_CLOSE_BUTTON' | translate }}</button>
  </div>
  <div class="modal-body">
    <mat-tab-group
      mat-align-tabs="center"
      [(selectedIndex)]="onlineChargeMediator.onlineChargeTabGroupIndex"
    >
      <mat-tab disabled>
        <ng-template mat-tab-label>
          <span
            class="round-tab"
            title="{{ 'CARDOPERATIONS_ONLINE_CHARGE_TAB1_LABEL' | translate }}"
          >
            <i class="icon icon-balance_charge"></i>
          </span>
        </ng-template>
        <ng-container *ngIf=" onlineChargeMediator.onlineChargeEvent == 'INITIAL_STATE' ">
          <app-first-step
            [modalType]="modalType"
            [modalInput]="modalInput"
            [concreteMediator]="onlineChargeMediator"
            (firstStepCompleted) = "onlineChargeMediator.onNextTab()"
          ></app-first-step>
        </ng-container>
      </mat-tab>
      <mat-tab disabled>
        <ng-template mat-tab-label>
          <span
            class="round-tab"
            title="{{ 'CARDOPERATIONS_ONLINE_CHARGE_TAB2_LABEL' | translate }}"
          >
            <i class="icon icon-card2"></i>
          </span>
        </ng-template>
        <ng-container *ngIf=" onlineChargeMediator.onlineChargeEvent == 'AMOUNT_SELECTED' ">
          <app-second-step
            [concreteMediator]="onlineChargeMediator"
            [viewParams]="onlineChargeMediator.firstStepEmission"
          ></app-second-step>
        </ng-container>
      </mat-tab>
      <mat-tab disabled>
        <ng-template mat-tab-label>
          <span
            class="round-tab"
            title="{{ 'CARDOPERATIONS_ONLINE_CHARGE_TAB4_LABEL' | translate }}"
          >
            <i class="icon icon-complete"></i>
          </span>
        </ng-template>

        <div class="tab-pane" role="tabpanel" id="complete">
          <div class="text-center" *ngIf=" onlineChargeMediator.onlineChargeEvent == 'TERMS_AGREED' ">
            <app-transactions
              [paymentType]="onlineChargeMediator.selectedPaymentType"
              [etisalatRequiredParams]="onlineChargeMediator.etisalatRequiredParams"
              (onError)="onError()"
            ></app-transactions>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div *ngIf="modalType === 'CardDetail'">
  <div class="modal-header">
    <h3
      class="modal-title"
      [innerHTML]="'CARDOPERATIONS_CARD_DETAIL_HEADER_LABEL' | translate"
    ></h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="homeCardLogsListArea cardStatementArea" style="display: block">
    <app-card-detail
      [modalInput]="modalInput"
    ></app-card-detail>
  </div>
</div>